export default __webpack_public_path__ + "static/media/level-5.5bf274b5.png";